var Utils = require('@amzn/aws-workdocs-web-client-common').Utils;

(function() {
    'use strict';

    angular.module('GorillaBoy.DocumentViewer')
        .directive('feedbackInputComponent', [
            '$log',
            '$timeout',
            '$document',
            '$translate',
            'DocumentUtilities',
            'AppConstants',
            'FeatureManagerService',
            'Features',
            'SourceConstant',
            'SignalProvider',
            'DocumentService',
            'BrowserService',
            'MetricEvents',
            'ClientMetricsService',
            feedbackInputComponent
        ]);

    function feedbackInputComponent($log, $timeout, $document, $translate, DocumentUtilities, AppConstants, FeatureManagerService,
        Features, SourceConstant, SignalProvider, DocumentService, BrowserService, MetricEvents, ClientMetricsService) {
        var addOverallFeedback = $translate.instant('RIGHT_NAV.FEEDBACK_PANEL.ADD_OVERALL_FEEDBACK'),
            topLevelPublicFeedback = $translate.instant('RIGHT_NAV.FEEDBACK_PANEL.ADD_TOP_FEEDBACK.PUBLIC'),
            topLevelPrivateFeedback = $translate.instant('RIGHT_NAV.FEEDBACK_PANEL.ADD_TOP_FEEDBACK.PRIVATE'),
            replyPublicFeedback = $translate.instant('RIGHT_NAV.FEEDBACK_PANEL.ADD_FEEDBACK_REPLY.PUBLIC'),
            draftPublishingModeText = $translate.instant('RIGHT_NAV.SUMMARIZE_YOUR_THOUGHTS') + ' ' + $translate.instant('RIGHT_NAV.OPTIONAL'),
            replyPrivateFeedback = $translate.instant('RIGHT_NAV.FEEDBACK_PANEL.ADD_FEEDBACK_REPLY.PRIVATE'),
            publishFeedbackText = $translate.instant('FEEDBACK_INPUT_COMPONENT.PUBLISH_FEEDBACK_LABEL'),
            postFeedbackText = $translate.instant('FEEDBACK_INPUT_COMPONENT.POST_FEEDBACK_LABEL'),
            postReplyText = $translate.instant('FEEDBACK_INPUT_COMPONENT.POST_REPLY_LABEL');

        return {
            restrict: 'E',
            scope: {
                onSubmit: '&',
                draftPublishingMode : '@',
                isOverAllInput : '@',
                onCancel: '&',
                submitButtonText: '@',
                feedbackObject: '=',
                //Please beaware, parentFeedbackObject corressponds to the thread level feedback object
                //and not it's direct parent in the feedback chain
                parentFeedbackObject: '='
            },
            templateUrl: './document-viewer/feedback_input_component.html',
            link: function($scope, $element, $attrs) {
                var FEEDBACK_VISIBILITY = AppConstants.FEEDBACK_VISIBILITY,
                    feedbackTypes = AppConstants.FeedbackTypes,
                    $commentEl = $element.find("textarea"),
                    $scrollWrapper = $element.parents(".scrollWrapper"),
                    $feedbackInputContainer = $element.find(".feedback-input-container"),
                    textareaPreviousHeight = null,
                    MIN_SCROLL_HEIGHT = 64;
                var commentEloffset = $commentEl[0].offsetHeight - $commentEl[0].clientHeight;

                $scope.atMentionsEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.FEEDBACK_AT_MENTIONS);

                $scope.documentState = $scope.$parent.documentState;
                $scope.autoCompleteComponent = false;
                $scope.mentions = [];
                //Normalize capital/lowercase to a boolean value
                $scope.draftPublishingMode = (($scope.draftPublishingMode || '').toLowerCase() === "true");

                if ($scope.parentFeedbackObject) {
                    $scope.enforcePrivateFeedback = $scope.parentFeedbackObject.Visibility === FEEDBACK_VISIBILITY.PRIVATE || ($scope.feedbackObject && !$scope.feedbackObject.inEditMode && $scope.feedbackObject.Visibility === FEEDBACK_VISIBILITY.PRIVATE);
                }

                //Always the immediate parent should override the enforcing the private feedback
                if ($scope.feedbackObject && $scope.feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_PUBLISHED) {
                    $scope.enforcePrivateFeedback = $scope.feedbackObject.Visibility === FEEDBACK_VISIBILITY.PRIVATE;
                }

                $scope.draftEditingMode = false;
                $scope.newTopLevelAnnotation = false;

                if ($scope.feedbackObject) {
                    if ($scope.feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                        $scope.draftEditingMode = true;
                    } else if ($scope.feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_INPUT) {
                        $scope.newTopLevelAnnotation = true;
                    }
                }

                $scope.ignoreMessageValidation = false;
                if (($scope.feedbackObject && $scope.feedbackObject.inEditMode) || $scope.draftPublishingMode) {
                    $scope.ignoreMessageValidation = true;
                }
                $scope.isOverAllCommentReply = ($scope.feedbackObject && !!$scope.feedbackObject.CommentId) || ($scope.parentFeedbackObject && !!$scope.parentFeedbackObject.CommentId);

                if ($scope.isOverAllInput || $scope.draftPublishingMode) {
                    $timeout(function() {
                        $scope.__registerDocumentClickHandler();
                        $commentEl.focus();
                    }, 0, false);
                    $scope.$on('$destroy', function() {
                        $document.off('click', $scope.__docClickEventHandler);
                    });
                }

                $scope.$watch('formData.feedbackText', function(newVal, oldVal) {
                    newVal = newVal || '';
                    if ($scope.draftPublishingMode) {
                        $scope.documentState.draftPublishingText = newVal;
                    } else if ($scope.isOverAllInput) {
                        $scope.documentState.overallCommentText = newVal;
                    } else if (($scope.draftEditingMode && newVal !== $scope.feedbackObject.Text) || !$scope.draftEditingMode) {
                        $scope.documentState.otherFeedbackText[$scope.getParentAnnotationId()] = newVal;
                    }
                    textAreaAutoResize($commentEl);
                });

                $scope.$watch('formData.isPrivate', function(newVal, oldVal) {
                    if (newVal === undefined) {
                        return;
                    }
                    if (newVal === true && $scope.isOverAllInput) {
                        $scope.formData.notifyCollaborators = false;
                    }
                });

                if ($scope.draftPublishingMode) {
                    $scope.$on(SignalProvider.FeedbackInput.HIDE_DRAFT_PUBLISHING_TEXTFIELD_WITH_NO_TEXT, function() {
                        $scope.$applyAsync(function() {
                            $scope.__resetFormData();
                            if ($scope.isOverAllInput) {
                                $scope.$parent.rightPanelView.forceShowingOverallComment = false;
                            } else if ($scope.draftPublishingMode) {
                                $scope.$parent.rightPanelView.forceHidingDraftPublishingComponent = true;
                            }
                        });
                    });
                }

                if (!$scope.draftPublishingMode && !$scope.isOverAllInput) {
                    $scope.$on(SignalProvider.Sidebar.FocusFeedbackInput, function() {
                        $element.find('textarea').focus();
                    });
                }

                $scope.__docClickEventHandler = function(event) {
                    if ($(event.target).parents('.atwho-container').length > 0) {
                        return;
                    }
                    if (!$.contains($element.get(0), event.target)) {
                        $scope.$applyAsync(function() {
                            if ($scope.isOverAllInput) {
                                $scope.$parent.rightPanelView.forceShowingOverallComment = false;
                            } else if ($scope.draftPublishingMode) {
                                $scope.$parent.rightPanelView.forceHidingDraftPublishingComponent = true;
                            }
                        });
                        $document.off('click', $scope.__docClickEventHandler);
                    }
                };

                $scope.__registerDocumentClickHandler = function() {
                    $document.on('click', $scope.__docClickEventHandler);
                };

                var timeoutAutoCompleteComponentShow = null;
                $scope.__scrollWrapperListener = function(evt) {
                    if ($scope.autoCompleteComponent && $scope.autoCompleteComponent.controllers['@'].view.visible()) {
                        $scope.autoCompleteComponent.controllers['@'].view.hide();
                        if (timeoutAutoCompleteComponentShow) {
                            $timeout.cancel(timeoutAutoCompleteComponentShow);
                        }
                        timeoutAutoCompleteComponentShow = $timeout(function() {
                            //We need to check again because the component could've been destroyed
                            if ($scope.autoCompleteComponent) {
                                $scope.autoCompleteComponent.controllers['@'].view.show();
                            }
                        }, 50, false);
                    }
                };
                $scrollWrapper.on('scroll', $scope.__scrollWrapperListener);
                $scope.$on('$destroy', function() {
                    $document.off('click', $scope.__docClickEventHandler);
                    $scrollWrapper.off('scroll', $scope.__scrollWrapperListener);
                    if ($scope.autoCompleteComponent) {
                        $scope.autoCompleteComponent.shutdown();
                        $scope.autoCompleteComponent = false;
                    }
                    if (timeoutShowFullAtMentionList) {
                        $timeout.cancel(timeoutShowFullAtMentionList);
                        timeoutShowFullAtMentionList = null;
                    }
                });

                $scope.getPlaceholderText = function() {
                    if ($scope.draftPublishingMode) {
                        return draftPublishingModeText;
                    }
                    if ($scope.isOverAllInput) {
                        return addOverallFeedback;
                    }
                    if (($scope.feedbackObject && $scope.feedbackObject.inReplyMode) || $scope.parentFeedbackObject) {
                        return ($scope.formData.isPrivate ? replyPrivateFeedback : replyPublicFeedback);
                    }
                    return ($scope.formData.isPrivate ? topLevelPrivateFeedback : topLevelPublicFeedback);
                };

                // This method returns the parent annotation ID of a reply draft.
                // It returns empty string ('') if it's a new selection.
                $scope.getParentAnnotationId = function() {
                    if ($scope.feedbackObject === null) return '';

                    // If new text selection or region, the feedbackObject.AnnotationId field contains 'draft-feedback-'.
                    if ($scope.feedbackObject.AnnotationId && DocumentService.isGeneratedDraftFeedbackId($scope.feedbackObject.AnnotationId)) return '';
                    if ($scope.feedbackObject.AnnotationId) return $scope.feedbackObject.AnnotationId;
                    if ($scope.feedbackObject.CommentId) return $scope.feedbackObject.CommentId;
                    return '';
                };

                $scope.hasHighlightedText = function() {
                    //Show the "Paste highlighted text" button only for top level annotations
                    return $scope.feedbackObject && $scope.feedbackObject.AnnotationId && !$scope.feedbackObject.inReplyMode && !$scope.feedbackObject.inEditMode && !$scope.parentFeedbackObject && ($scope.feedbackObject.AnnotationType === AppConstants.ANNOTATION_TYPE.HIGHLIGHT);
                };
                $scope.pasteHighlightedText = function() {
                    var commentBox = $commentEl.get(0);
                    var text = $scope.$parent.copyHighlightedText();
                    var comment = $commentEl.val();
                    var cursor = getCommentCursorPosition(commentBox);

                    // leading and trailing whitespace in comment box is ignored
                    if (comment) {
                        var pre = comment.slice(0, cursor);
                        var post = comment.slice(cursor);
                        comment = pre + ' ' + text + post;
                        // set cursor after pasted text
                        cursor = pre.length + text.length + 1;
                    } else {
                        comment = text;
                        cursor = text.length;
                    }

                    $timeout(function() {
                        $scope.formData.feedbackText = comment.slice(0, $scope.maxChars);
                        setCommentCursorPosition(commentBox, cursor);
                    }, 0);
                };

                /* This function copys users selected text in document to clipboard if no text is selected in 
                 * the feedback component. The reason to add copy listener here is that when text is selected
                 * on document preview, the focus will be set to feedback input component if feedback is enabled.
                 */
                $scope.copyEventHandler = function(event) {
                    // IMPORTANT: Angularjs wraps the original clipboard event. The wrapped event does not have clipboardData.
                    // Therefore, we need to interact with original event.
                    var originalEvent = event.originalEvent;

                    var selectedTextLength = $commentEl[0].selectionEnd - $commentEl[0].selectionStart;
                    // If there is anything select, do not copy from document preview
                    // If the annotation is not text highlight, do not copy from document preview
                    if(selectedTextLength !== 0 || $scope.documentState.pendingAnnotation.type !== AppConstants.ANNOTATION_TYPE.HIGHLIGHT) {
                        return;
                    }

                    var text = $scope.$parent.copyHighlightedText();
                    if (BrowserService.isIE()) {
                        Utils.copyTextToClipboard(document, text);
                    } else {
                        if (originalEvent.clipboardData) {
                            originalEvent.clipboardData.setData('text/plain', text);
                            originalEvent.preventDefault();
                        } else {
                            Utils.copyTextToClipboard(document, text);
                        }
                    }
                };

                /* see http://stackoverflow.com/questions/263743/how-to-get-caret-position-in-textarea */
                function getCommentCursorPosition(element) {
                    if (element.selectionStart) {
                        return element.selectionStart;
                    } else if (document.selection) {
                        element.focus();

                        var r = document.selection.createRange();
                        if (!r) {
                            return 0;
                        }

                        var re = element.createTextRange(),
                            rc = re.duplicate();
                        re.moveToBookmark(r.getBookmark());
                        rc.setEndPoint('EndToStart', re);

                        return rc.text.length;
                    }

                    return 0;
                }

                /* see http://stackoverflow.com/questions/512528/set-cursor-position-in-html-textbox */
                function setCommentCursorPosition(element, caretPos) {
                    element.value = element.value;
                    // ^ this is used to not only get "focus", but
                    // to make sure we don't have it everything -selected-
                    // (it causes an issue in chrome, and having it doesn't hurt any other browser)

                    if (element) {
                        if (element.createTextRange) {
                            var range = element.createTextRange();
                            range.move('character', caretPos);
                            range.select();
                            return true;
                        } else {
                            // (el.selectionStart === 0 added for Firefox bug)
                            if (element.selectionStart || element.selectionStart === 0) {
                                element.focus();
                                element.setSelectionRange(caretPos, caretPos);
                                return true;
                            } else {
                                // fail city, fortunately this never happens (as far as I've tested) :)
                                element.focus();
                                return false;
                            }
                        }
                    }
                }

                /* This function is for auto resize */
                function textAreaAutoResize(el) {
                    // When the textarea is initially empty and the height of it is 'auto', the actual height
                    // will be 0px. MIN_SCROLL_HEIGHT prevent the text area to be too small.
                    var scrollHeight = Math.max(el[0].scrollHeight, MIN_SCROLL_HEIGHT);
                    $(el).css('height', 'auto').css('height', scrollHeight + commentEloffset);
                }
                /* end */

                /**
                 * This function just checks the BCR (Bounding Client Rect) of the scrolling pane and the current input element (textarea + surrounding borders + buttons). Then
                 * decides how to reposition the scrollpane such that the input element is scrolled into view.
                 *
                 * This function does not execute in $digest() loop.
                 */
                $scope.__positionComponent = function(dontFocus) {
                    var boundingClientRect = $feedbackInputContainer.get(0).getBoundingClientRect();
                    var wrapperBoundingClientRect = $scrollWrapper.get(0).getBoundingClientRect();
                    if (boundingClientRect.top > $scrollWrapper.height() - $feedbackInputContainer.height()) {
                        $log.debug("Positioning the input component upwards for the bottom to be visisble");
                        // scroll 40px more to avoid ".drafts-pending-container"
                        $scrollWrapper.scrollTop($scrollWrapper.scrollTop() + (boundingClientRect.bottom - wrapperBoundingClientRect.bottom) + 40);
                    } else if ($scope.documentState.selectedPerson && boundingClientRect.top < 140) {
                        //140px is the boundingClientRect().bottom value of the "Showing XYZ Feedback" div.
                        //If this is the first annotation for the page and there's a filtering by user then push the scrollbar up by 200px
                        $scrollWrapper.scrollTop($scrollWrapper.scrollTop() - (wrapperBoundingClientRect.top - boundingClientRect.top) - 200);
                    } else if (boundingClientRect.top < 60) {
                        //If this is the first annotation for the page then push the scrollbar up by 100px
                        $scrollWrapper.scrollTop($scrollWrapper.scrollTop() - (wrapperBoundingClientRect.top - boundingClientRect.top) - 100);
                    }

                    //Do not focus the input element if it's focused already (based on the dontFocus param)
                    if(!dontFocus) {
                        $commentEl.focus();
                        //IE by default does not set the cursor to the end
                        if (BrowserService.isIE() || BrowserService.isMSEdge()) {
                            var val = $commentEl.val();
                            $commentEl.get(0).setSelectionRange(val.length, val.length);
                        }
                    }
                };


                if (!$scope.isOverAllInput && !$scope.draftPublishingMode) {
                    //When this component is used for drafts or pagewise feedback input position it accordingly.
                    if (!$scope.newTopLevelAnnotation) {
                        //Do focus when editing a draft annotation
                        $timeout($scope.__positionComponent, 0, false);
                    } else {
                        //The last param "true" will NOT focus the input box by default, the box will be focus on mouseup in the feedbackDrawnDirective.js to start taking input from the user
                        $timeout($scope.__positionComponent, 0, false, true);
                    }
                }


                $scope.__resetFormData = function() {
                    $scope.formData = {
                        //Notify Contributors checkbox is enabled by default. We want to spread the message more than less
                        notifyCollaborators : !(FeatureManagerService.isFeatureEnabled(Features.UI.DISABLE_NOTIFY_CONTRIBUTORS)),
                        feedbackText : '',
                        isPrivate : false
                    };
                    //We need to reset the state for the Overall Comment field because it's not destroyed
                    $scope.mentions = [];
                    textareaPreviousHeight = null;
                    if ($scope.enforcePrivateFeedback) {
                        $scope.formData.isPrivate = true;
                    } else if ($scope.feedbackObject && $scope.feedbackObject.Visibility === FEEDBACK_VISIBILITY.PRIVATE) {
                        $scope.formData.isPrivate = true;
                    }
                };

                $scope.__resetFormData();
                $scope.maxChars = 2048;

                if ($scope.draftPublishingMode) {
                    $scope.formData.feedbackText = $scope.documentState.draftPublishingText;
                } else if ($scope.isOverAllInput) {
                    $scope.formData.feedbackText = $scope.documentState.overallCommentText;
                } else {
                    $scope.formData.feedbackText = $scope.documentState.otherFeedbackText[$scope.getParentAnnotationId()] || '';
                }

                //Only assign the view model value if there's no cached value assignment happening from above logic
                if ($scope.feedbackObject && $scope.feedbackObject.inEditMode && !$scope.formData.feedbackText) {
                    $scope.formData.feedbackText = $scope.feedbackObject.Text;
                }

                $scope.getSubmitButtonText = function() {
                    if ($scope.isOverAllInput || $scope.draftPublishingMode) {
                        return publishFeedbackText;
                    }
                    if ($scope.feedbackObject && $scope.feedbackObject.inEditMode) {
                        return postFeedbackText;
                    }
                    if (!$scope.submitButtonText) {
                        $scope.submitButtonText = postReplyText;
                    }
                    return $scope.submitButtonText;
                };

                //Set the onSubmit and onCancel functions to NOOP if they're not assigned
                $scope.onSubmit = $scope.onSubmit ? $scope.onSubmit : angular.noop;
                $scope.onCancel = $scope.onCancel ? $scope.onCancel : angular.noop;

                $scope.submitFeedback = function() {
                    if ($scope.isOverAllCommentReply) {
                        $scope.formData.notifyCollaborators = false;
                    }
                    //Implemented log when notifyContributors is unchecked.
                    if(!$scope.formData.notifyCollaborators)
                    {
                        ClientMetricsService.recordCounterEvent(MetricEvents.PUBLISH_COMMENTS_WITHOUT_NOTIFICATIONS, 1);
                    }
                    
                    if($scope.formData.notifyCollaborators)
                    {
                        ClientMetricsService.recordCounterEvent(MetricEvents.PUBLISH_COMMENTS_WITH_NOTIFICATIONS, 1);
                    } 
                    $scope.onSubmit({
                        feedbackText: $scope.formData.feedbackText,
                        extraData : {
                            feedbackObject: $scope.feedbackObject,
                            parentFeedbackObject : $scope.parentFeedbackObject,
                            notifyCollaborators : $scope.formData.notifyCollaborators,
                            isPrivate : $scope.formData.isPrivate
                        }
                    });
                    if ($scope.isOverAllInput) {
                        $scope.documentState.overallCommentText = '';
                        $scope.$parent.rightPanelView.forceShowingOverallComment = false;
                        $timeout(function() {
                            $scope.$parent.reselectFeedback();
                        }, 250, false);
                        $commentEl.attr("style", ""); //unset the auto expanded height
                        $scope.__resetFormData();
                    } else if ($scope.draftPublishingMode) {
                        $scope.documentState.draftPublishingText = '';
                    } else {
                        $scope.documentState.otherFeedbackText[$scope.getParentAnnotationId()] = '';
                    }
                };

                $scope.cancelFeedback = function() {
                    $scope.onCancel({
                        feedbackObject: $scope.feedbackObject
                    });
                    $scope.__resetFormData();
                    if ($scope.draftPublishingMode) {
                        $scope.documentState.draftPublishingText = '';
                    } else if ($scope.isOverAllInput) {
                        $scope.documentState.overallCommentText = '';
                    } else {
                        $scope.documentState.otherFeedbackText[$scope.getParentAnnotationId()] = '';
                    }
                };

                $scope.__parseEmails = function(inputText) {
                    $scope.mentions = DocumentUtilities.parseTextAndReturnEmails(inputText);
                };

                //We're not using ng-keypress and ng-keydown to avoid $digest() loop for every character press.

                /**
                 * Added for the sake of handling ENTER key.
                 * Due to ngModelOptions debounced binding, the value is not getting cleared in the formData.feedbackText.
                 * So let's blur() the input field first that way Angular won't bind the old value back to model, then we'll do our handling
                 * on top of it.
                 */
                $commentEl.on('keypress', function keypressHandlerFn($event) {
                    if ($event.keyCode && $event.keyCode === AppConstants.KeyCodes.ENTER && !$event.shiftKey) {
                        //Prevent default here to avoid having a new line in the input
                        $event.preventDefault();
                        //If user quickly presses enter before the ngDisabled can kick in (it's delayed to ngModelOptions debouncing),
                        //do manual validation in that case
                        if (!$scope.ignoreMessageValidation && (!$commentEl.val() || $commentEl.val().trim() === '')) {
                            return;
                        }
                        //Blur/Focus are fired synchronously, so let that happen in seperate tick
                        $timeout(function() {
                            $commentEl.blur();
                            $timeout(function() {
                                //We need to explictly copy the value to the model because the debouncing in ng-model.
                                //This is not necessary when you click on the button, becauase the sync blur will bind it.
                                $scope.formData.feedbackText = $commentEl.val();
                                $scope.submitFeedback();
                            }, 0);
                        }, 0, false);
                    }
                });

                function createAutoComplete() {
                    if ($scope.autoCompleteComponent) {
                        return;
                    }

                    var principals = $scope.documentState.principals;
                    var peopleList = (principals.direct || []).concat(principals.inherited || [])
                        .filter(function(principal) {
                            return principal.Type === AppConstants.PrincipalTypes.USER;
                        })
                        .map(function(user) {
                            if (!user.EmailAddress) {
                                user.EmailAddress = '';
                            }
                            return user;
                        });

                    //Compute the unique list based on User IDs
                    peopleList = _.uniqBy(peopleList, 'Id');

                    $commentEl.atwho({
                        at : '@',
                        displayTpl : '<li><div class="icon-SVG_profile sprite-icon"></div><div class="user-info">${GivenName} ${Surname}</div><div class="user-aux-info">${EmailAddress}</div></li>',
                        insertTpl : '${EmailAddress}',
                        data: peopleList,
                        callbacks : {
                            sorter: function(query, items, searchKey) {
                                var _results;
                                _results = [].concat(items);
                                return _results.sort(function(a, b) {
                                    return a.GivenName > b.GivenName ? 1 : (a.GivenName < b.GivenName ? -1 : 0);
                                });
                            },
                            filter : function(query, data, searchKey) {
                                var regexp = new RegExp(query, 'i');
                                var retVal = data.filter(function(user) {
                                    return !!((user.GivenName && user.GivenName.match(regexp)) || (user.Surname && user.Surname.match(regexp)));
                                });
                                return retVal;
                            },
                            beforeInsert : function(value, $li) {
                                commentElOnInputEventCallback();
                                return value;
                            }
                        }
                    });
                    $scope.autoCompleteComponent = $commentEl.data('atwho');
                }
                if ($scope.atMentionsEnabled) {
                    $scope.$watch('documentState.principals', function(newVal, oldVal) {
                        if (!newVal || (newVal === oldVal)) {
                            return;
                        }
                        if (!newVal.direct && !newVal.inherited) {
                            return;
                        }
                        if ((newVal.direct && newVal.direct.length) || (newVal.inherited && newVal.inherited.length)) {
                            createAutoComplete();
                        }
                    });
                    if ($scope.documentState.principals &&
                        ($scope.documentState.principals.direct || $scope.documentState.principals.inherited)) {
                        createAutoComplete();
                    }
                }

                //"input" event notifies us in case copy/paste and undo/redo operations also
                $commentEl.on('input', commentElOnInputEventCallback);
                function commentElOnInputEventCallback() {
                    if (!$scope.atMentionsEnabled) {
                        return;
                    }
                    $timeout(function() {
                        $scope.__parseEmails($commentEl.val());
                        $scope.$digest();
                    }, 0, false);
                }
                /**
                 * Added for the sake of handling ESC key and Ctrl+C
                 */
                $commentEl.on('keydown', function keydownHandler($event) {
                    // Handle ESC
                    if ($event.keyCode && $event.keyCode === AppConstants.KeyCodes.ESC) {
                        textareaPreviousHeight = null;
                        $timeout(function() {
                            $commentEl.blur();
                            $timeout(function() {
                                $scope.$parent.reselectFeedback();
                            }, 10, false);
                        }, 0, false);
                        $scope.$evalAsync('cancelFeedback()');
                    }

                    // Handle Ctrl+C
                    // Only IE need to listen to Ctrl+C. All other browsers listen to copy event
                    if (BrowserService.isIE() && $event.ctrlKey) {
                        if ($event.keyCode == 67) // c
                        {
                            var text = $scope.$parent.copyHighlightedText();
                            Utils.copyTextToClipboard(document, text);
                        }
                    }
                });

                $scope.showAtMentionsMenu = function() {
                    if (!$scope.autoCompleteComponent) {
                        return;
                    }
                    $timeout(function() {
                        var cursor = getCommentCursorPosition($commentEl.get(0));
                        var comment = $commentEl.val();
                        if (comment) {
                            var pre = comment.slice(0, cursor);
                            var post = comment.slice(cursor);
                            if (pre.substring(pre.length - 1) !== '@') {
                                if (pre.substring(pre.length - 1) !== ' ') {
                                    pre += ' ';
                                }
                                comment = pre + '@' + post;
                                // set cursor after pasted text
                                cursor = pre.length + 1;
                            }
                        } else {
                            comment = '@';
                            cursor = 1;
                        }

                        //Set the value synchronously
                        $commentEl.val(comment);

                        //Do not set in the View Model because the AtJS will modify the text field as user types it
                        //$scope.formData.feedbackText = comment;

                        // set cursor after pasted text
                        setCommentCursorPosition($commentEl.get(0), cursor);
                        $commentEl.focus();

                        //We need to check again because the component could've been destroyed
                        if ($scope.autoCompleteComponent) {
                            $scope.autoCompleteComponent.controllers['@'].lookUp();
                            $scope.autoCompleteComponent.controllers['@'].view.show();
                        }
                    }, 0, false);
                };

                $scope.fullAtMentionListVisible = false;
                var timeoutShowFullAtMentionList = null;
                $scope.hideFullAtMentionList = function($event) {
                    $scope.fullAtMentionListVisible = false;
                    if (timeoutShowFullAtMentionList) {
                        $timeout.cancel(timeoutShowFullAtMentionList);
                        timeoutShowFullAtMentionList = null;
                    }
                };

                $scope.showFullAtMentionList = function($event) {
                    if (timeoutShowFullAtMentionList) {
                        $timeout.cancel(timeoutShowFullAtMentionList);
                    }
                    timeoutShowFullAtMentionList = $timeout(function() {
                        $scope.fullAtMentionListVisible = true;
                    }, 150);
                };

                //The component could be prefilled with some text, so parse the text for emails
                if ($scope.formData.feedbackText) {
                    $scope.__parseEmails($scope.formData.feedbackText);
                }
            }
        };
    }
}());
